export default __webpack_public_path__ + "static/media/Reports.PieChart.d88e1f67.svg";